import api from 'api'

type SetChargeUpfrontRequest = {
  companyId: number
  chargeUpfront?: boolean
  invoiceDueDays?: number
}

export const setChargeUpfront = async ({
  companyId,
  chargeUpfront,
  invoiceDueDays,
}: SetChargeUpfrontRequest) => {
  const response = await api.put(`/admin/company/${companyId}/charge_upfront`, {
    chargeUpfront,
    invoiceDueDays,
  })
  return response.data
}
